<template>
  <lsm-widget
    :icon="image ? undefined : 'fa-hourglass-half'"
    :image="image ?? undefined"
    :image-aspect-ratio="IMAGE_ASPECT_RATIO"
    data-testid="countdown-widget"
    :title="image ? undefined : heading"
  >
    <rich-text-content
      class="text-center mt-4"
      :data="message"
    />
  </lsm-widget>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RichTextContent from '@/components/rich-text/RichTextContent.vue';
import LsmWidget from './LsmWidget.vue';

const props = defineProps<{
  daysRemaining: number;
  /** Custom heading, shown with the icon when there is no picture; null shows the number of days. */
  title?: string | null;
  /** Picture shown at the top instead of the icon. */
  image?: string | null;
  /** Rich text (HTML). */
  message: string;
}>();

/** Same frame as the shift widgets' pictures, so a tall photo cannot stretch the card. */
const IMAGE_ASPECT_RATIO = 2;

const { t } = useI18n();

const automaticTitle = computed(() => props.daysRemaining === 0
  ? t('countdown.today')
  : t('countdown.days', props.daysRemaining));

/** Only shown without a picture: a picture replaces the title bar and its icon. */
const heading = computed(() => props.title ?? automaticTitle.value);
</script>
